import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<any, addTeamBody>({
    query: (body) => ({
      url: `v4/pitch-owner/tournaments/${body.tournamentId}/custom/add-match`,
      method: 'POST',
      body: body.body,
    }),
  });

type addTeamBody = {
  tournamentId: number;
  body: {
    tournament_match_group_id: number;
    round: number;
    referral_round: number;
    position: string;
    tournament_team_1_id: number;
    tournament_team_2_id: number;
  };
};
